import type { ReactNode } from 'react';

/** Horizontal rule with a centred, letter-spaced label. */
export function SectionRule({ children }: { children: ReactNode }) {
  return (
    <div className="my-10 mb-6 flex items-center gap-6 text-[13px] font-semibold uppercase tracking-[0.28em] text-fg-muted before:h-px before:flex-1 before:bg-line after:h-px after:flex-1 after:bg-line">
      {children}
    </div>
  );
}
